import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
export const clearDowloadAccountReportList = () => {
  return {
    'type': ActionTypes.CLEAR_DOWNLOADED_ACCOUNT_REPORT,
  };
};
export const downloadAccountReportList = (payload) => (dispatch) => {
  console.log(payload);
  return dispatch(
    apiActionCreator({
      'endpoint': '/account-report/detail/excel',
      'authenticated': true,
      'types': [
        ActionTypes.DOWNLOADING_ACCOUNT_REPORT,
        ActionTypes.DOWNLOADED_ACCOUNT_REPORT,
        [ActionTypes.DOWNLOADED_ACCOUNT_REPORT_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': payload,
    })
  );
};
